import React from "react"
import {Box, Button, Grid, Typography,} from "@mui/material"

import {customColors} from "customColors"
import {Link} from "react-router-dom"

import getTopBrandTableColumns from "components/dashboard/dashboard-top-brand/dashboardTopBrandColumns"
import {TopMatch} from "models/topBrands"
import {OrderType, PaginatedResponse, SearchFilter} from "../../../models";
import {SbPaginatedDatagrid} from "components/commons";

export interface DashboardTopBrandProps
{
	topBrandData: PaginatedResponse<TopMatch> | null
	handleCallback: (pagination: SearchFilter) => void
	pagination: SearchFilter
	loading: boolean
}
export interface DashboardTopBrandState
{
	pagination: SearchFilter
}
export class DashboardTopBrand extends React.Component<DashboardTopBrandProps, DashboardTopBrandState>
{
	private readonly columns: any

	constructor(props: DashboardTopBrandProps)
	{
		super(props)
		this.columns = getTopBrandTableColumns()
		this.state = {
			pagination: {
				pageSize: this.props.pagination.pageSize,
				pageId: this.props.pagination.pageId,
				orderBy: "id",
				orderType: OrderType.ASCENDING,
			},
		}
	}

	private onPaginationChanged = (pageId: number, pageSize: number): void => {
		if(pageSize !== this.state.pagination.pageSize){
			this.setState(
				() => ({
					pagination: {
						...this.state.pagination,
						pageSize: pageSize,
						pageId: 0
					},
				}),
				() => this.props.handleCallback(this.state.pagination)
			)
		}
		else {
			this.setState(
				() => ({
					pagination: {
						...this.state.pagination,
						pageId: pageId
					},
				}),
				() => this.props.handleCallback(this.state.pagination)
			)
		}
	}

	render () {
		return (
			<>
				{
					!this.props.loading ?
					<>
						<Box sx={{
							backgroundColor: customColors.storebookGreen,
							paddingLeft: 3,
							paddingY: 2,
							color: 'white',
							textAlign: 'left'
						}}>
							<Typography sx={{fontSize: 16}}>
								Top Brand e immobili
							</Typography>
						</Box>

						<Grid container>
							<Grid item xs={12}>
								<SbPaginatedDatagrid columns={this.columns}
													 data={this.props.topBrandData}
													 pagination={this.state.pagination}
													 onPaginationChanged={this.onPaginationChanged}
								/>
							</Grid>
						</Grid>

						<footer>
							<Box sx={{
								backgroundColor: 'background.default',
								padding: '10px',
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center'
							}}>
								<Link to="/brand" key="showAllBrands">
									<Button
										variant="contained"
										disableElevation
										sx={{
											textTransform: 'none',
											backgroundColor: 'secondary.main',
											color: 'white',
											paddingX: 6,
											height: 28,
											":hover": {
												backgroundColor: "secondary.main"
											},
										}}>
										Vedi tutti i brand registrati
									</Button>
								</Link>
							</Box>
						</footer>
					</>
						:
					null
				}
			</>
		);
	}
}
